/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Atelier_Point_2Inputs */

const en_atelier_point_2 = /** @type {(inputs: Atelier_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase orders confirmed line by line, or with a counter-proposal`)
};

/**
* | output |
* | --- |
* | "Purchase orders confirmed line by line, or with a counter-proposal" |
*
* @param {Atelier_Point_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const atelier_point_2 = /** @type {((inputs?: Atelier_Point_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Atelier_Point_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_atelier_point_2(inputs)
});